import { ValidationResult } from "@components/WizardCst/types";

export const validateEditorial = (): ValidationResult => ({
  valid: true,
  errors: {},
});
